import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { Controller, Control } from 'react-hook-form';
import { TextArea } from 'components/ui';
import { FeedbackFormData } from '../constants';

export interface CommentsSectionProps {
  control: Control<FeedbackFormData>;
  readOnly?: boolean;
}

export const CommentsSection = ({
  control,
  readOnly = false,
}: CommentsSectionProps): ReactElement => {
  return (
    <Box mb={40}>
      <Typography
        sx={{
          fontSize: pxToEm(16),
          fontWeight: 500,
          color: '#383838',
        }}
      >
        Want to share anything else?
      </Typography>
      <Controller
        name="comment"
        control={control}
        render={({ field }) => (
          <TextArea
            {...field}
            placeholder={readOnly ? undefined : 'Enter comments (Optional)'}
            rows={6}
            style={{
              boxShadow: 'none',
            }}
            minHeight={100}
            maxHeight={100}
            disabled={readOnly}
          />
        )}
      />
    </Box>
  );
};

